import React from 'react'
import './dec.css'


export default function Dec() {
  return (
    <>
    <img src="images/page404.gif" alt="" style={{"width":"100%", "height":"90vh"}}/>
    </>
  )
}
